import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../../design/theme';
import './AuthPages.css';

export const SignupPage: React.FC = () => {
  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: '700px' }}>
        <div className="auth-header">
          <h1>Join Exibrain</h1>
          <p>Choose your account type to get started</p>
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr', 
          gap: theme.spacing.lg,
          marginTop: theme.spacing.xl 
        }}>
          {/* Individual Option */}
          <Link to="/signup/individual" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div style={{
              padding: theme.spacing.xl,
              border: `1px solid ${theme.colors.neutral[200]}`,
              borderRadius: '8px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: 'white',
              height: '100%'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = theme.colors.brand.main;
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = theme.colors.neutral[200];
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <div style={{ fontSize: '40px', marginBottom: theme.spacing.md }}>👤</div>
              <h3 style={{ marginBottom: theme.spacing.sm }}>Individual</h3>
              <p style={{ fontSize: '14px', color: theme.colors.neutral[500] }}>
                For developers, researchers, and personal projects.
              </p>
            </div>
          </Link>

          {/* Enterprise Option */}
          <Link to="/signup/enterprise" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div style={{
              padding: theme.spacing.xl,
              border: `1px solid ${theme.colors.neutral[200]}`,
              borderRadius: '8px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              backgroundColor: 'white',
              height: '100%'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.borderColor = theme.colors.brand.main;
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.borderColor = theme.colors.neutral[200];
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <div style={{ fontSize: '40px', marginBottom: theme.spacing.md }}>🏢</div>
              <h3 style={{ marginBottom: theme.spacing.sm }}>Enterprise</h3>
              <p style={{ fontSize: '14px', color: theme.colors.neutral[500] }}>
                For companies and teams requiring advanced governance.
              </p>
            </div>
          </Link>
        </div>

        <div style={{ marginTop: theme.spacing.xxl, textAlign: 'center' }}>
          <p style={{ fontSize: '14px', color: theme.colors.neutral[600] }}>
            Already have an account? <Link to="/login" style={{ color: theme.colors.brand.main, fontWeight: '600', textDecoration: 'none' }}>Sign In</Link>
          </p>
        </div>
      </div>
    </div>
  );
};
